/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Optional note - transcript or comments about the media
 * @export
 * @interface Note2
 */
export interface Note2 {
}

/**
 * Check if a given object implements the Note2 interface.
 */
export function instanceOfNote2(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Note2FromJSON(json: any): Note2 {
    return Note2FromJSONTyped(json, false);
}

export function Note2FromJSONTyped(json: any, ignoreDiscriminator: boolean): Note2 {
    return json;
}

export function Note2ToJSON(value?: Note2 | null): any {
    return value;
}

